(() => {
  const groupSelectors = {
    feature: '[data-colulu-managed-group="feature"], .swris-feature-grid, .lullme-v2-feature-cards__grid, .air-figma-feature-grid, .drimug-feature-grid, .hugwarmer-feature-grid',
    special: '[data-colulu-managed-group="special"], .swris-mode-cards, .lullme-v2-sounds__benefits, .pdp-feature-stack, .ride-v2-feature-grid, .drimug-card-rail, .hugwarmer-mode-grid',
    detail: '[data-colulu-managed-group="detail"], .swris-details__rail, .lullme-v2-product-details__track, .morby-figma-details__rail, .drimug-details__rail, .hugwarmer-details__rail',
    scene: '[data-colulu-managed-group="scene"], .morby-figma-scene__rail, .lullme-v2-scenes__track, .drimug-scene-grid, .hugwarmer-scenes__rail',
    faq: '[data-colulu-managed-group="faq"], .pdp-qa-list, .lullme-v2-faq-section > div:last-child, .drimug-faq > div:last-child, .hugwarmer-faq > div:last-child',
    related: '[data-colulu-managed-group="related"], .pdp-related-grid, .lullme-v2-related-section > div:last-child',
  };
  const copyText = (node, value) => {
    if (node && value) node.textContent = value;
  };

  const initConfig = (config) => {
    if (config.dataset.managedReady === 'true') return;
    config.dataset.managedReady = 'true';
    const root = config.closest('.page-shell, .hugwarmer-page') || config.parentElement;
    if (!root) return;

    if (config.dataset.showSection === 'false') {
      root.hidden = true;
      return;
    }
    const firstHeading = root.querySelector('h2');
    copyText(firstHeading, config.dataset.sectionHeading);
    const intro = firstHeading?.closest('header, div')?.querySelector('p') || root.querySelector('header p');
    copyText(intro, config.dataset.sectionIntro);

    const sources = [...config.querySelectorAll('[data-colulu-managed-block]')];
    const groups = [...new Set(sources.map((source) => source.dataset.managedGroup).filter(Boolean))];
    groups.forEach((group) => {
      const container = root.querySelector(groupSelectors[group] || `[data-colulu-managed-group="${group}"]`);
      if (!container || container.hasAttribute('data-colulu-native-related')) return;
      const originals = [...container.children].map((item) => item.cloneNode(true));
      if (!originals.length) return;
      const groupSources = sources.filter((source) => source.dataset.managedGroup === group);
      container.replaceChildren(...groupSources.map((source) => {
        const requestedIndex = Math.max(0, Number(source.dataset.originalIndex || 1) - 1);
        const item = (originals[requestedIndex] || originals[0]).cloneNode(true);
        item.dataset.managedBlockId = source.dataset.managedBlockId || '';
        const image = item.matches('img') ? item : item.querySelector('img');
        if (image && source.dataset.imageSrc) {
          image.src = source.dataset.imageSrc;
          image.removeAttribute('srcset');
        }
        if (image && source.dataset.imageAlt) image.alt = source.dataset.imageAlt;
        if (image) image.style.objectPosition = source.dataset.imagePosition || 'center center';

        const heading = group === 'faq'
          ? item.querySelector('summary')
          : group === 'related'
            ? item.querySelector('strong')
            : item.querySelector('h3, h4, strong');
        const body = group === 'related' ? item.querySelector('span') : item.querySelector('p');
        copyText(heading, source.dataset.heading);
        copyText(body, source.dataset.body);

        const anchor = item.matches('a') ? item : item.querySelector('a');
        if (anchor && source.dataset.link) anchor.href = source.dataset.link;
        return item;
      }));
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-colulu-managed-config]').forEach(initConfig);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const item = document.querySelector(`[data-managed-block-id="${event.detail?.blockId || ''}"]`);
    if (!item) return;
    item.scrollIntoView({ block: 'center', behavior: 'smooth' });
    item.animate?.([{ outline: '3px solid #709889' }, { outline: '0 solid transparent' }], { duration: 1200 });
  });
})();
